import styled from 'styled-components'

export const TabsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  transition: all 0.25s ease-in-out;
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundSecundary};
`

export const Tab = styled.button<{ active: boolean }>`
  font-family: ${({ theme }) => theme.fonts.main};
  margin-left: 45px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  background: white;
  border: 0;
  outline: 0;
  color: #3e4954;
  padding-bottom: 17px;
  ${({ active }) =>
    active &&
    `
        color: #1600FF;
        border-bottom: 2px solid #1600ff;
    `};
`
